/* @format */

import store from '@/stores';

/**
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {function} next
 */
export function accountReactivateContactGuard(to, from, next) {
    const isAdmin = store.getters.isAdmin;
    const isClientUser = store.getters.isClientUser;

    if (isAdmin || !isClientUser) {
        return next(from.path ?? '/');
    }

    next();
}
